module.exports = __webpack_public_path__ + "img/emasesa_simple.b43d7fc0.svg";